import React from "react";
import { Card, Button } from "react-bootstrap";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useClientAuth } from "../../context/ClientAuthContext";
export default function CartSummary({ total, tva }) {
  const navigate = useNavigate();
  const { currentClient, handleClientLogout } = useClientAuth();
  console.log("currentClient", currentClient);
  return (
    <Card className="cart-summary w-100">
      <Card.Body>
        <h6>RÉCAPITULATIF</h6>
        <hr />
        <div className="d-flex justify-content-between">
          <span>Total de la commande :</span>
          <span className="prix">
            {total.toFixed(3)} <span className="dt"> dt</span>
          </span>
        </div>
        <div className="d-flex justify-content-between mt-2">
          <span className="tva">DONT TVA :</span>
          <span className="prix-tva">
            {tva} <span className="dt-tva">dt</span>
          </span>
        </div>
        <Button
          className="add-to-cart w-100 mt-3"
          onClick={() =>
            navigate(currentClient ? "/payment" : "/login-cart-page")
          }>
          VALIDER LA COMMANDE
        </Button>
      </Card.Body>
    </Card>
  );
}
